import { render, staticRenderFns } from "./shopify.vue?vue&type=template&id=fc4c3da8&"
import script from "./shopify.vue?vue&type=script&lang=js&"
export * from "./shopify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports